import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './action-button.styl';

import { pickContextTypes } from '../context-types';


@WixConnect(styles)
export default class ActionButton extends React.Component {

  static contextTypes = pickContextTypes('fullScreen');

  static propTypes = {
    rounded: React.PropTypes.bool,
    icon: React.PropTypes.string,
    label: React.PropTypes.any,
    onClick: React.PropTypes.func,
    children: React.PropTypes.element,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    rounded: false,
    onClick: _.noop,
  };

  @autobind
  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();

    this.props.onClick();
  }

  get label() {
    const { label } = this.props;
    if (!label) {
      return null;
    }

    return (
      <span styleName="label">{label}</span>
    );
  }

  render() {
    const { rounded, label, icon, className } = this.props;
    const { fullScreen } = this.context;

    const styleNames = classnames('action-button', {
      rounded,
      'with-label': Boolean(label),
      'full-screen': fullScreen,
    });

    return (
      <a href=""
         styleName={styleNames}
         className={className}
         onClick={this.handleClick}>
        {this.label}
        <Icon styleName="icon"
              name={icon} />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/action-button/action-button.js